var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMosque(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.9498,
    height: 50.13766,
    viewBox: "0 0 42.9498 50.13766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4aa41;}.cls-2{fill:#d0cfce;}.cls-3{fill:#9b9b9a;}.cls-4{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-4,.cls-5{fill:none;stroke:#000;}.cls-5{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.9498,28.13766H15.9498c-.55195-.00033-.99967,.44685-1,.9988v5.4212h-5.5V9.13766c0-.55229-.44772-1-1-1H3.4498c-.55229,0-1,.44771-1,1V49.13766c-.00033,.55195,.44685,.99967,.9988,1H41.9498c.55195,.00033,.99967-.44685,1-.9988V29.13766c0-.55228-.44772-1-1-1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 28.9417,
    cy: 13.14556,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.9496,34.13766l-3.4962,5.2442c-.32852,.49281-.50381,1.07183-.5038,1.6641v8.0917h8v-8.0917c.00002-.59227-.17528-1.17129-.5038-1.6641l-3.4962-5.2442Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.8834,21.33006H2.975c-.42974,.00013-.81151-.27431-.9483-.6817L.0521,14.77196c-.17529-.52431,.10764-1.09145,.63195-1.26675,.10196-.03409,.20875-.05153,.31625-.05165H10.899c.55273,.00063,1.00029,.44921,.99966,1.00194-.00013,.1096-.01825,.21844-.05366,.32216l-2.0157,5.8765c-.13873,.40409-.51866,.67558-.9459,.6759Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.8834,35.54296H2.975c-.42971,.00015-.81148-.27425-.9483-.6816L.0521,28.98486c-.1753-.52431,.10763-1.09145,.63194-1.26675,.10196-.03409,.20875-.05153,.31626-.05165H10.899c.55273,.00043,1.00045,.44884,1.00003,1.00157-.00009,.10979-.01824,.21883-.05373,.32273l-2.0157,5.8769c-.13897,.40396-.51901,.67519-.9462,.6753Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.4097,30.13766H17.4897c-.36499-.00014-.70101-.19884-.877-.5186-.75733-1.37263-1.15723-2.91371-1.1629-4.4814,0-6.0654,6.0556-11,13.5-11s13.5,4.9346,13.5,11c-.00573,1.5677-.4057,3.10878-1.1631,4.4814-.17598,.31978-.512,.51848-.877,.5186Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.4498,10.13816c-.4278,0-4.7647,.1177-5.294-.0444-.52783-.16257-.82416-.72202-.6621-1.25L4.9937,.70706c.16193-.52801,.72124-.82478,1.24925-.66285,.31724,.09729,.56555,.34561,.66285,.66285l2.5,8.1367c.16212,.52799-.13423,1.08748-.6621,1.25-.09525,.02917-.19428,.04413-.2939,.0444Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 28.9417,
    y: 8.14556,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.4496,25.13766c-.00294,1.39981-.36076,2.77602-1.04,4H17.4896c-.67924-1.22398-1.03706-2.60019-1.04-4,0-5.52,5.6-10,12.5-10s12.5,4.48,12.5,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.9496,49.13766H3.4496"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.9496,46.06196V29.13766h26v16.9243"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.4496,34.55766h7.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 28.9417,
    cy: 13.14556,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 28.9417,
    y: 8.14556,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.9496,41.04766v8.09h-8v-8.09c.00406-.59295,.17754-1.17238,.5-1.67l2.84-4.25,.66-.99,.66,.99,2.84,4.25c.32246,.49762,.49594,1.07705,.5,1.67Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3.4496,
    y1: 46.06196,
    x2: 3.4496,
    y2: 34.55766
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 8.4496,
    y1: 34.55766,
    x2: 8.4496,
    y2: 46.06196
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "3.45 14.45366 3.45 9.13766 8.45 9.13766 8.45 14.45366"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "8.883 20.33066 2.975 20.33066 1 14.45366 10.899 14.45366 8.883 20.33066"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "8.883 34.54266 2.975 34.54266 1 28.66666 10.899 28.66666 8.883 34.54266"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "3.45 9.13766 5.95 1.00066 8.45 9.13766"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3.4496,
    y1: 20.33026,
    x2: 3.4496,
    y2: 28.66636
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 8.4496,
    y1: 20.33026,
    x2: 8.4496,
    y2: 28.66636
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosque);
export default __webpack_public_path__ + "static/media/mosque.e4db825d379bf0bed93350c55cef4414.svg";
export { ForwardRef as ReactComponent };